import { Tabs as MuiTabs } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useEffect, useRef, useState } from 'react'
import Tab from './Tab'
import { Icon } from 'packages/eid-icons'

const ScrollableDiv = styled('div')({
    overflow: 'scroll !important',
    '&::-webkit-scrollbar': {
        display: 'none !important',
        width: '0',
        height: '0',
    },
})

const HorizontalTabs = (props) => {
    const OFFSET = props.offset ? props.offset : 50
    const ref = useRef(null)
    const [scrollableDiv, setScrollableDiv] = useState(null)
    const [scrollLeft, setScrollLeft] = useState(0)
    useEffect(() => {
        if (ref?.current) {
            setScrollableDiv(ref.current.firstChild)
            setScrollLeft(ref.current.firstChild.scrollLeft)
        }
    }, [])
    useEffect(() => {
        if (scrollableDiv) {
            const handleScroll = () => {
                setScrollLeft(scrollableDiv.scrollLeft)
            }
            scrollableDiv.addEventListener('scroll', handleScroll)
            return () => {
                scrollableDiv.removeEventListener('scroll', handleScroll)
            }
        }
    })
    return (
        <>
            {props?.customScroll ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {scrollLeft > 0 && (
                        <Icon
                            direction="left"
                            sx={{
                                width: '3rem',
                                height: '3rem',
                                cursor: 'pointer',
                            }}
                            name="Arrow"
                            onClick={() => {
                                if (scrollLeft <= 0) {
                                    return
                                }
                                const { y } =
                                    scrollableDiv?.getBoundingClientRect()
                                scrollableDiv?.scrollTo(
                                    scrollableDiv.scrollLeft - OFFSET,
                                    y,
                                )
                            }}
                        />
                    )}
                    <ScrollableDiv>
                        <MuiTabs
                            sx={{
                                scrollBehavior: 'smooth',
                            }}
                            ref={ref}
                            {...props}
                            variant="standard"
                            scrollButtons={false}
                        />
                    </ScrollableDiv>

                    {scrollLeft <
                        scrollableDiv?.scrollWidth -
                            scrollableDiv?.offsetWidth && (
                        <Icon
                            direction="right"
                            sx={{
                                width: '3rem',
                                height: '3rem',
                                cursor: 'pointer',
                            }}
                            name="Arrow"
                            onClick={() => {
                                const { y } =
                                    scrollableDiv?.getBoundingClientRect()
                                scrollableDiv?.scrollTo(
                                    scrollableDiv.scrollLeft + OFFSET,
                                    y,
                                )
                            }}
                        />
                    )}
                </div>
            ) : (
                <>
                    <MuiTabs {...props} />
                </>
            )}
        </>
    )
}

HorizontalTabs.Tab = Tab

export default HorizontalTabs
